import { render } from "./rbac.authorization.k8s.io.clusterrolebinding.vue?vue&type=template&id=ee787166"
import script from "./rbac.authorization.k8s.io.clusterrolebinding.vue?vue&type=script&lang=js"
export * from "./rbac.authorization.k8s.io.clusterrolebinding.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__